import { Checkbox as MaterialCheckbox, FormControlLabel } from "@mui/material";

export function Checkbox({ label, ...rest }) {
    return (
        <FormControlLabel control={<MaterialCheckbox {...rest} />} label={label} />
    );
}